import type { TFunction } from "i18next";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { store } from "../../../store";
import { LengthUnit } from "../../../api";

function cmToMeters(t: TFunction<"translation", undefined>, cm: number): string | undefined {
    return `${(cm / 100).toFixed(2)} m`;
}

const CM_PER_INCH = 2.54;
const INCHES_PER_FOOT = 12;
function cmToFeetAndInches(t: TFunction<"translation", undefined>, cmLength: number): string {
    const totalInches = cmLength / CM_PER_INCH;
    const feet = Math.floor(totalInches / INCHES_PER_FOOT);
    const remainingInches = Math.round(totalInches % INCHES_PER_FOOT);

    if (feet === 0) {
        return `${remainingInches} in.`;
    }
    return `${feet} ft. ${remainingInches} in.`;
}

export type DistanceProps = {
    cm: number;
    className?: string;
};

const FALLBACK_LENGTH_UNIT = LengthUnit.METERS;

export const Distance = observer(({ cm, className }: DistanceProps): JSX.Element => {
    const unit =
        store.serviceOwnUser.user?.lengthUnit ??
        store.servicePublicSettings.publicSetting?.defaultLengthUnit ??
        FALLBACK_LENGTH_UNIT;
    const { t } = useTranslation();

    return (
        <span className={className}>
            {unit === LengthUnit.METERS && cmToMeters(t, cm)}
            {unit === LengthUnit.FEET && cmToFeetAndInches(t, cm)}
        </span>
    );
});
